import { render, staticRenderFns } from "./MonitorLayout.vue?vue&type=template&id=41866cbb"
import script from "./MonitorLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./MonitorLayout.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports